<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col class="mb-3">
          <legend>Borrower Information</legend>
          <div class="col-md-12">
            <div>
              <div><strong>Primary Borrower</strong></div>
              <div>{{ borrower }}</div>
            </div>
            <div v-if="entity" class="mt-2">
              <div><strong>Entity</strong></div>
              <div>{{ entity.name }}</div>
            </div>
            <address-display v-if="entity" class="mt-2" :address="entity.businessAddress"/>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <vue-form-generator
            :model="model"
            :schema="form.schema"
            :options="form.options"
            ref="paymentForm"
          />
        </b-col>
      </b-row>
      <payment-display
        v-if="model.paymentMethod"
        :payment-method="selectedPaymentMethod"
        :display-header="false"
      />
      <payment-method-create-modal
        ref="createPaymentMethodModal"
        :show-account-type-field="showAccountTypeField"
        :show-option-field="showOptionField"
        :payment-method-type="paymentMethodType"
        @created="onCreatedPaymentMethod"
      />
    </b-col>
  </b-row>
</template>


<script>
import AddressDisplay from '@/components/utils/address/AddressDisplay';
import PaymentMethodCreateModal from '@/components/payments/create/PaymentMethodCreateModal';
import PaymentDisplay from '@/components/payments/display/PaymentMethodDisplay';
import FORM_SCHEMA from '@/components/payments/create/resources/selectSchema';

export default {
  components: {
    AddressDisplay,
    PaymentMethodCreateModal,
    PaymentDisplay,
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
    showAccountTypeField: {
      type: Boolean,
      default: false,
    },
    showOptionField: {
      type: Boolean,
      default: true,
    },
    paymentMethodType: {
      type: String,
      default: 'ACH',
    },
    excludePaymentMethodType: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      model: { paymentMethod: null },
    };
  },
  computed: {
    borrower() {
      const contact = this.$store.getters.profile.contact;
      return `${contact.firstName} ${contact.lastName}`;
    },
    entity() {
      return this.$store.getters.entities.find(e => e.id === this.loan.entity_id);
    },
    paymentMethods() {
      let paymentMethods = {};

      if (this.excludePaymentMethodType.length > 0) {
        paymentMethods = this.$store.getters.paymentMethods.filter(
          value => !this.excludePaymentMethodType.includes(value.method));
      } else {
        paymentMethods = this.$store.getters.paymentMethods;
      }

      // remove payment check cause it's not allowed use it anymore for creation
      paymentMethods = paymentMethods.filter(pMethod => pMethod.method !== 'check');

      return paymentMethods ?
        paymentMethods.map(pMethod => ({ id: pMethod.id, name: pMethod.name })) :
        [];
    },
    selectedPaymentMethod() {
      const paymentMethod = this.$store.getters.paymentMethods.find(pm =>
        pm.id === this.model.paymentMethod);
      this.$emit('selected-payment-method', paymentMethod);
      return paymentMethod;
    },
    form() {
      return FORM_SCHEMA.schema(this.paymentMethods, this.openPaymentMethodModal);
    },
  },
  methods: {
    validate() {
      return this.$refs.paymentForm.validate();
    },
    reset() {
      this.model.paymentMethod = null;
    },
    openPaymentMethodModal() {
      this.$refs.createPaymentMethodModal.show();
    },
    onCreatedPaymentMethod(value) {
      this.model.paymentMethod = value.id;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/payments/create/PaymentForm.vue